import { useEffect } from 'react';

const GoogleTagManager = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-TLLRW6QH';
    script.nonce='GoCMSWebNAUSGHDV'
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});
    };

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <></>;
};

export default GoogleTagManager;
